var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0417 18.3333V6.4479L7.25004 10.2396L5.20837 8.12498L12.5 0.833313L19.7917 8.12498L17.75 10.2396L13.9584 6.4479V18.3333H11.0417ZM3.75004 24.1666C2.94796 24.1666 2.26133 23.8811 1.69014 23.3099C1.11896 22.7387 0.833374 22.0521 0.833374 21.25V16.875H3.75004V21.25H21.25V16.875H24.1667V21.25C24.1667 22.0521 23.8811 22.7387 23.3099 23.3099C22.7388 23.8811 22.0521 24.1666 21.25 24.1666H3.75004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.da3bdf32dce5bf9014c1440a3de4d951.svg";
export { ForwardRef as ReactComponent };